import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

const initCaseStudiesSwiper = (scope = document) => {
    scope.querySelectorAll('.case-studies-swiper-wr').forEach((wrapper) => {
        const swiperEl = wrapper.querySelector('.swiper');

        if (!swiperEl || swiperEl.swiper) {
            return;
        }

        const slidesCount = swiperEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;

        if (!slidesCount) {
            return;
        }

        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');
        const swiper = new Swiper(swiperEl, {
            modules: [Autoplay, Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            navigation: nextEl && prevEl ? {
                nextEl,
                prevEl,
            } : undefined,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
            autoplay: slidesCount > 1 ? {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 1024,
            } : false,
        });

        swiperObserver(swiper);
    });
};

initCaseStudiesSwiper();
window.initCaseStudiesSwiper = initCaseStudiesSwiper;
